<mat-list>
  <app-course-member-item *ngFor="let user of (usersObservable | async)" [user]="user" [course]="course"></app-course-member-item>
</mat-list>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-member-list/course-member-list.component.html